import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { salesOrderItemsGetAction } from "../../../redux/actions/sales-action";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import CreateEditViewPur from "../../../components/purchase-section/purchase-order/create-edit-view-pur";
import { purchaseViewAction } from "../../../redux/actions/purchase-action";

const AddPurchase = () => {
  const location = useLocation();
  const suggestedProducts = location.state?.orderDetail || [];
  const totals = location.state?.orderData || {};
  const { itemId, type } = useParams();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [searchParams] = useSearchParams();
  //

  const cloneID = searchParams.get("cloneID");
  const transfer=searchParams.has("transfer");
  const isClone = cloneID ? true : false;
  //
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [enableConfirm, setEnableConfirm] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(purchaseViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else {
      setLoading(true);
      dispatch(salesOrderItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };
  const onErrPur = (data) => {
    setLoading(false);
  };

  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.orderData || orderDetail?.vendorDetails?.[0] || {};
  const soVendorDetails = orderDetail?.vendorDetails?.[0] || {};

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true}
          list={true}
          title={`${isClone ? "Clone" : "Add"} Purchase order`}
          confirm={enableConfirm}
        >
          <CreateEditViewPur
            //  <CreateEditViewPurchase
            setEnableConfirm={setEnableConfirm}
            transfer={transfer===true}
            isClone={isClone}
            payto={isClone ? orderData?.pot_pay_to_address : soVendorDetails?.sott_pay_to_address}
            shipto={isClone ? orderData?.pot_ship_to_address : soVendorDetails?.sott_ship_to_address}
            page="add"
            pageType="purchase"
            type={type}
            toValidate={true}
            orderDetail={
              suggestedProducts?.length > 0
                ? suggestedProducts
                : orderDetail?.itemData ?? []
            }
            vendorDetails={
              isClone
                ? [{ ...vendorDetails, customer_invoice_number: "", pot_id: null }]
                : [
                    {
                      ...vendorDetails,
                      // Footer totals computed on the CSV upload page
                      ...(suggestedProducts?.length > 0 ? totals : {}),
                    },
                  ]
            }
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddPurchase;
